import './period-month-item.style.sass';
import template from './period-month-item.tpl.pug';

export default {
    selector: 'dbAPeriodMonthItem',
    template: template(),
    bindings: {
        name: '<',
        change: '<',
        balance: '<',
        selected: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/component/calendar-period/component/period-month-item/period-month-item.cmpt.js